import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import usePageMetadata from '../hooks/usePageMetadata';
import { useAuth } from '../context/AuthContext';
import { authSection, btnLg, btnPrimary, containerForm, focusRing, inputClass, labelClass } from '../styles/ui';

const RegisterPage = () => {
  const { register, authStatus } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: '', phone: '', email: '', password: '' });
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  usePageMetadata({
    title: 'Create Account | Fresh & Homely',
    description: 'Create a Fresh & Homely account to shop fresh meat, seafood, dairy and groceries online.',
    canonicalPath: '/register',
  });

  if (authStatus === 'authenticated') {
    return <Navigate to="/account" replace />;
  }

  const handleChange = (field) => (event) => setForm((prev) => ({ ...prev, [field]: event.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await register({ ...form, name: form.name.trim(), email: form.email.trim() });
      navigate(`/verify-email?email=${encodeURIComponent(form.email.trim())}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <section className={authSection}>
        <div className={`${containerForm} w-full`}>
          <div className="bg-white/90 backdrop-blur-sm rounded-4xl border border-emerald-50 p-8 shadow-floating">
            <h1 className="serif text-3xl text-emerald-950 mb-2 text-center">Create your account</h1>
            <p className="text-ink-secondary text-center mb-8">Join Fresh &amp; Homely to start shopping</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="name" className={labelClass}>Full name</label>
                <input id="name" required value={form.name} onChange={handleChange('name')} className={inputClass} autoComplete="name" />
              </div>
              <div>
                <label htmlFor="phone" className={labelClass}>Phone</label>
                <input id="phone" type="tel" required value={form.phone} onChange={handleChange('phone')} className={inputClass} autoComplete="tel" />
              </div>
              <div>
                <label htmlFor="email" className={labelClass}>Email</label>
                <input id="email" type="email" required value={form.email} onChange={handleChange('email')} className={inputClass} autoComplete="email" />
              </div>
              <div>
                <label htmlFor="password" className={labelClass}>Password</label>
                <input id="password" type="password" required minLength={8} value={form.password} onChange={handleChange('password')} className={inputClass} autoComplete="new-password" />
              </div>

              {error && <p className="text-sm text-red-600">{error}</p>}

              <button
                type="submit"
                disabled={submitting}
                className={`w-full ${btnPrimary} ${btnLg}`}
              >
                {submitting ? 'Creating account...' : 'Create Account'}
              </button>
            </form>

            <p className="mt-6 text-center text-sm text-ink-secondary">
              Already have an account?{' '}
              <Link to="/login" className={`text-emerald-700 hover:text-emerald-800 font-medium ${focusRing}`}>
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default RegisterPage;
